<script setup>
import { Head, router, useForm } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import AppLayout from '../../Layouts/AppLayout.vue'

const props = defineProps({
  invitationEmail: { type: String, required: true },
  currentEmail: { type: String, required: true },
  signedUrl: { type: String, required: true },
})

const { t } = useI18n()

const logoutForm = useForm({})

const logoutAndContinue = () => {
  logoutForm.post(route('logout'), {
    onSuccess: () => {
      // Land back on the same signed accept URL once the session is dropped,
      // so the now-guest browser sees the registration form directly.
      window.location.href = props.signedUrl
    },
  })
}

const goHome = () => {
  router.visit('/')
}
</script>

<template>
  <Head :title="t('messages.invitations.error.wrong_account_title')" />

  <AppLayout>
    <div class="flex justify-center mt-12">
      <Card class="max-w-md w-full">
        <template #content>
          <div class="flex flex-col items-center gap-4 text-center">
            <i class="pi pi-user-edit text-5xl text-amber-500"></i>
            <h1 class="text-xl font-medium m-0">
              {{ t('messages.invitations.error.wrong_account_title') }}
            </h1>
            <p class="text-sm text-gray-600 m-0">
              {{
                t('messages.invitations.error.wrong_account_description', {
                  current: currentEmail,
                  invitation: invitationEmail,
                })
              }}
            </p>
            <div class="flex gap-2 mt-2">
              <Button outlined severity="secondary" @click="goHome">
                {{ t('messages.invitations.error.wrong_account_cancel') }}
              </Button>
              <Button :loading="logoutForm.processing" @click="logoutAndContinue">
                {{ t('messages.invitations.error.wrong_account_logout') }}
              </Button>
            </div>
          </div>
        </template>
      </Card>
    </div>
  </AppLayout>
</template>
